function PrevadzkaAUdrPlynZar(){
    return(
        <div>
            PrevadzkaAUdrPlynZar
        </div>
    );
};

export default PrevadzkaAUdrPlynZar;